import { ActionTypes } from '../actions'

export interface TrialExpiredDialogState {
  open: boolean
}

const initialState: TrialExpiredDialogState = {
  open: false,
}

export const trialExpiredDialog = (
  state: TrialExpiredDialogState = initialState,
  action: { type: string }
): TrialExpiredDialogState => {
  switch (action.type) {
    case ActionTypes.SHOW_TRIAL_EXPIRED_DIALOG:
      return {
        ...state,
        open: true,
      }
    case ActionTypes.HIDE_TRIAL_EXPIRED_DIALOG:
      return {
        ...state,
        open: false,
      }
    default:
      return state
  }
}
